import { TZDate } from '@date-fns/tz';

import { type InfluencerDropResponse } from '../types';

import { getShortTimeZoneName } from '@/modules/shop/helpers/dateFormatters';
import { type ShopDropConfig } from '@/modules/shop/types';

function parseContentfulDate(
  isoString: string,
  targetTimeZone: string
): TZDate {
  const dateWithoutZ = isoString.replace('Z', '');
  const parts = dateWithoutZ.match(
    /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/
  );

  if (parts) {
    const [, year, month, day, hour, minute, second] = parts;
    return new TZDate(
      parseInt(year),
      parseInt(month) - 1,
      parseInt(day),
      parseInt(hour),
      parseInt(minute),
      parseInt(second),
      targetTimeZone
    );
  }

  return new TZDate(dateWithoutZ, targetTimeZone);
}

export function transformShopDropResponse(
  data: InfluencerDropResponse
): ShopDropConfig | null {
  const [item] = data.data.influencerCollection.items;

  if (!item) {
    return null;
  }

  const [latestDrop] = item.dropsCollection?.items ?? [];

  if (!latestDrop) {
    return null;
  }

  const dropDate = parseContentfulDate(
    latestDrop.dropDate,
    latestDrop.timeZone
  );
  const shortTimeZoneName = getShortTimeZoneName(latestDrop.timeZone, dropDate);

  return {
    username: item.username,
    dropDate: dropDate.toISOString(),
    dropCountdownDate: parseContentfulDate(
      latestDrop.countdownDate,
      latestDrop.timeZone
    ).toISOString(),
    showUntil: parseContentfulDate(
      latestDrop.endDate,
      latestDrop.timeZone
    ).toISOString(),
    timeZoneName: shortTimeZoneName,
    heroImages: {
      desktop: item.desktopBanner?.url,
      mobile: item.mobileBanner?.url,
    },
    useInfluencerLayout: item.useInfluencerLayout,
    socials: {
      instagram: item.instagramFollowers,
      tiktok: item.tikTokFollowers,
      youtube: item.youTubeFollowers,
      depop: item.depopFollowers,
    },
    bio: item.bio,
    latestDrop: latestDrop ?? null,
  };
}
